import { request } from './request'

export function querySystemStatus() {
  return request.get('/system/status')
}

export function recordSiteVisit() {
  return request.post('/system/visit')
}
